import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=8dcd3018&scoped=true&"
import script from "./institutionList.vue?vue&type=script&lang=js&"
export * from "./institutionList.vue?vue&type=script&lang=js&"
import style0 from "./institutionList.vue?vue&type=style&index=0&id=8dcd3018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcd3018",
  null
  
)

export default component.exports